import { Component, OnInit } from '@angular/core';
import { UtilitiesService } from '@services/utilities.service';
import { RolePrivilegeService } from '@services/role-privilege.service';
import { BehaviorSubject } from 'rxjs';
import { getDistributorTableColumns } from '../../../distributor.data';
import { TableColumn } from '@shared/interface/table.interface';
import { API } from '@config/constants/api.constant';
import { DistributorService } from '../../../distributor.service';

@Component({
  selector: 'app-teregistrasi-registered',
  styleUrls: ['./teregistrasi-registered.component.scss'],
  template: `
    <app-card-table-list
      [url]="API.LIST_DISTRIBUTOR_REGISTERED"
      [tableColumns]="tableColumns"
      [privilegeDetail]="privilegeDetailRegistered"
      [actionPathDetail]="distributorService.BasePathDistributorDetail + '/teregistrasi/registered/'"
      (totalCount)="onTotalCount($event)"
    />
  `,
})
export class TeregistrasiRegisteredComponent implements OnInit {
  tableColumns: TableColumn[] = getDistributorTableColumns('teregistrasi');
  privilegeDetailRegistered = new BehaviorSubject(false);

  public static totalCount = new BehaviorSubject(0);

  constructor(public utilities: UtilitiesService, private rolePrivilegeService: RolePrivilegeService, public distributorService: DistributorService) {}

  ngOnInit() {
    this.privilegeDetailRegistered.next(this.rolePrivilegeService.checkPrivilege('DISTRIBUTOR', 'LIST_TEREGISTRASI', 'TAB_LIST_REGISTERED', 'CTA_VIEW_DETAIL'));
    this.tableColumns = this.utilities.privilegeTableColumns(this.privilegeDetailRegistered.value, this.tableColumns);
  }

  onTotalCount = (e: number) => TeregistrasiRegisteredComponent.totalCount.next(e);

  protected readonly API = API;
}
